/**
 * @deprecated use SelectOption
 */
import { makeAlias } from "../util/make-alias";

export interface ISelectOption {
    value: string | Array<string> | number;
    label: string;
}

export class SelectOption implements ISelectOption {
    value: string | Array<string> | number;
    label: string;

    constructor(value: string | Array<string> | number, label: string) {
        this.value = value;
        this.label = label;
    }

    getName(): string {
        return makeAlias(this.label);
    }
}



// WEBPACK FOOTER //
// ./src/core/interfaces/select-option.ts